import dailyBalanceRoutes from '@src/cash-desk/daily-balance/daily-balance-routes.js';
import dsfinvkRoutes from '@src/cash-desk/dsfinvk/dsfinvk-routes.js';

export default [
    {
        path: '/cash-desk',
        name: 'cash_desk',
        component: () => import('@src/cash-desk/cash-desk.vue'),
        meta: {
            title: 'Kasse',
            role: 'ROLE_CASH_DESK',
        },
    },
    {
        path: '/cash-desk/my-transactions/list',
        name: 'cash_desk_my_transactions_list',
        component: () => import('@src/cash-desk/transactions/my-transactions-list.vue'),
        props(route: any) {
            return { ...route.params };
        },
        meta: {
            title: 'Meine Transaktionen',
            role: 'ROLE_CASH_DESK',
        },
    },
    {
        path: '/cash-desk/transactions/list',
        name: 'cash_desk_transactions_list',
        component: () => import('@src/cash-desk/transactions/transactions-list.vue'),
        props(route: any) {
            return { ...route.params };
        },
        meta: {
            title: 'Alle Transaktionen',
            role: 'ROLE_CASH_DESK_LIST_TRANSACTIONS',
        },
    },
    {
        path: '/cash-desk/transactions/detail/:id',
        name: 'cash_desk_transactions_detail',
        component: () => import('@src/cash-desk/transactions/transaction-detail.vue'),
        props(route: any) {
            return { id: Number.parseInt(route.params.id) };
        },
        meta: {
            title: 'Transaktionsdetails',
            role: 'ROLE_CASH_DESK',
        },
    },
    ...dailyBalanceRoutes,
    ...dsfinvkRoutes,
    {
        path: '/cash-desk/cash-deposit',
        name: 'cash_desk_cash_deposit',
        component: () => import('@src/cash-desk/transactions/transfer-transaction-create.vue'),
        props() {
            return { type: 'CASH_DEPOSIT' };
        },
        meta: {
            title: 'Bargeldeinlage',
            role: 'ROLE_CASH_DESK',
        },
    },
    {
        path: '/cash-desk/cash-withdrawal',
        name: 'cash_desk_cash_withdrawal',
        component: () => import('@src/cash-desk/transactions/transfer-transaction-create.vue'),
        props() {
            return { type: 'CASH_WITHDRAWAL' };
        },
        meta: {
            title: 'Bargeldentnahme',
            role: 'ROLE_CASH_DESK',
        },
    },
    {
        path: '/cash-desk/transfer-transaction-template-list',
        name: 'cash_desk_transfer_transaction_template_list',
        component: () => import('@src/cash-desk/settings/transfer-transaction-template-list.vue'),
        meta: {
            title: 'Geldtransfervorlagen',
            role: 'ROLE_CASH_DESK',
        },
    },
    {
        path: '/cash-desk/transfer-transaction-template-edit/:id',
        name: 'cash_desk_transfer_transaction_template_edit',
        component: () => import('@src/cash-desk/settings/transfer-transaction-template-edit.vue'),
        props(route: any) {
            return { id: Number.parseInt(route.params.id) };
        },
        meta: {
            title: 'Geldtransfervorlage bearbeiten',
            role: 'ROLE_CASH_DESK',
        },
    },
    {
        path: '/cash-desk/transfer-transaction-template-create',
        name: 'cash_desk_transfer_transaction_template_create',
        component: () => import('@src/cash-desk/settings/transfer-transaction-template-create.vue'),
        meta: {
            title: 'Neue Geldtransfervorlage erstellen',
            role: 'ROLE_CASH_DESK',
        },
    },
    {
        path: '/cash-desk/settings/terminal-diagnosis',
        name: 'cash_desk_settings_terminal_diagnosis',
        component: () => import('@src/cash-desk/settings/cash-desk-terminal-diagnosis.vue'),
        meta: {
            title: 'Terminal-Diagnose',
            role: 'ROLE_CASH_DESK',
        },
    },
];
